import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Tab from "./Tab/Tab";

import "./Tabs.css";

class Tabs extends React.Component {
  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired,
  };

  constructor(props) {
    super(props);
    this.scrollPlace = React.createRef();

    this.state = {
      activeTab: this.props.children[0].props.label,
    };
  }

  componentDidMount() {
    this.props.onQueryHandler(this.state.activeTab);
    this.smoothScroll(this.scrollPlace.current);
  }

    

  smoothScroll(target) {
    const { top } = target.getBoundingClientRect()
    window.scrollTo({
      top: top + window.pageYOffset,
      behavior: "smooth"
    });
  }
  
            

  onClickTabItem = (tab) => {
    this.setState({ activeTab: tab });
    this.props.onQueryHandler(tab);
  };

  render() {
    const {
      onClickTabItem,
      props: { children },
      state: { activeTab },
    } = this;
 
    return (
      <Fragment>
        <div className="mn-grid__row" ref={this.scrollPlace}>
          <div className="mn-grid__col">
            <div className="mn-card mn-RD-profile__bdrs-bottom-0">
              <div className="mn-card__body mn-card__body--pd-0">
                <div className="">
                  <nav className="uk-navbar-container uk-navbar-transparent c-RD-profile--h-70 c-profile-responsive-navbar uk-navbar mn-profile-nav--border">
                    <div className="uk-navbar-right">
                      <ul className="uk-navbar-nav">
                        {children.map((child) => {
                          if(child.props=== undefined) {
                            return null;
                          }
                          const { label } = child.props;

                          return (
                            <Tab
                              activeTab={activeTab}
                              key={label}
                              label={label}
                              onClick={onClickTabItem}
                            />
                          );
                        })}
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 
        <div className="tab-content"> */}
        {children.map((child) => {
          if(child.props=== undefined) {
            return null;
          }
          if (child.props.label !== activeTab) return undefined;
          return child.props.children;
        })}
        {/* </div> */}
      </Fragment>
    );
  }
}

export default Tabs;







  
        
      